export default class CharityProduct {
    constructor() {
        this.bindEvents()
    }

    calcAndApplyBoxHeight() {
        let productItems = document.getElementsByClassName('product-item') || null
        let charityProductTileElm = document.getElementsByClassName('product-item--charity')[0] || null

        productItems = [...productItems].filter((elm) => {
            return !elm.classList.contains('product-item--charity')
        })

        if (productItems.length === 0 || charityProductTileElm === null) {
            return;
        }

        let maxHeight = 0;
        productItems.forEach((elm) => {
            const rect = elm.getBoundingClientRect()
            if (maxHeight < rect.height) {
                maxHeight = rect.height
            }
        })

        if (maxHeight > 0) {
            charityProductTileElm.style.height = maxHeight + 'px'
        }
    }

    bindEvents() {
        this.calcAndApplyBoxHeight()

        window.addEventListener('resize', this.calcAndApplyBoxHeight)
    }
}
